// components/Wordmark.tsx — the UPLOAD wordmark: geometric caps, tuned tracking.
// Animated (hero only): each letter rises + fades in once (respects reduced-motion).
const LETTERS = ['U', 'P', 'L', 'O', 'A', 'D'] as const;

export function Wordmark({
  animated = false,
  className = '',
}: {
  animated?: boolean;
  className?: string;
}) {
  if (!animated) {
    return (
      <span className={`wordmark ${className}`} aria-label="UPLOAD">
        UPLOAD
      </span>
    );
  }
  return (
    <span className={`wordmark wordmark--hero ${className}`} role="img" aria-label="UPLOAD">
      {LETTERS.map((ch, i) => (
        <span
          key={ch}
          className="wm-letter"
          aria-hidden="true"
          style={{ animationDelay: `${i * 45}ms` }}
        >
          {ch}
        </span>
      ))}
    </span>
  );
}
